import { render, staticRenderFns } from "./OtherUserReceiveMessageDetail.vue?vue&type=template&id=749adba8&lang=pug"
import script from "./OtherUserReceiveMessageDetail.vue?vue&type=script&lang=ts"
export * from "./OtherUserReceiveMessageDetail.vue?vue&type=script&lang=ts"
import style0 from "./OtherUserReceiveMessageDetail.vue?vue&type=style&index=0&id=749adba8&prod&lang=scss&scopeed=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports